import React from "react";
import DatePicker from "react-datepicker";
import { forwardRef, useEffect, useState } from "react";
import { ISearchContext, useSearch } from "../SearchContext";
import { IFilterProps } from "./Filter";
import { BiCalendar } from "react-icons/bi";
import { IListing } from "../../../lib";

import "react-datepicker/dist/react-datepicker.css";

export interface IDateRangeProps extends IFilterProps {
  /*
   *  Classes to be placed on the input
   */
  dateInputClassNames?: string;

  context: ISearchContext;
}

export const DateRange: React.FC<IDateRangeProps> = (props) => {
  let context = props.context;

  useEffect(() => {
    // Register this filter in the search context if necessary.
    context.currentFilter &&
      !context.currentFilter.get(props.param) &&
      context.setFilter &&
      context.setFilter(props.param, (arg, value) => {
        let listing = arg as IListing;
        if (!value[0] || !value[1]) return true;
        if (!listing.bookings || !listing.bookings.length) return true;
        let retval = true;
        listing.bookings.forEach((booking) => {
          const blocked =
            /*(booking.startDate < value[1] && booking.endDate > value[1]) ||
            (booking.startDate <= value[0] && booking.endDate > value[0])*/
            !((value[0] < booking.startDate && value[1] < booking.startDate) ||
              (value[0] > booking.endDate && value[0] > booking.endDate));
          if (blocked) retval = false;
        });
        return retval;
      });
  }, [context.currentFilter]);

  let value = context.getFilterValue && context.getFilterValue(props.param);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  useEffect(() => {
    if (value && value[0]) {
      const year = parseInt(value[0].substring(0, 4), 10);
      const month = parseInt(value[0].substring(5, 7), 10) - 1;
      const day = parseInt(value[0].substring(8, 10), 10);
      let dt = new Date(year, month, day);
      setStartDate(dt);
    } else if (startDate) {
      setStartDate(null);
    }
    if (value && value[1]) {
      const year = parseInt(value[1].substring(0, 4), 10);
      const month = parseInt(value[1].substring(5, 7), 10) - 1;
      const day = parseInt(value[1].substring(8, 10), 10);
      let dt = new Date(year, month, day);
      setEndDate(dt);
    } else if (endDate) {
      setEndDate(null);
    }
  }, [value]);
  const CustomInput = forwardRef<
    HTMLInputElement,
    React.DetailedHTMLProps<
      React.InputHTMLAttributes<HTMLInputElement>,
      HTMLInputElement
    >
  >(({ value, onClick, placeholder }, ref) => (
    <input
      className={props.dateInputClassNames}
      onClick={onClick}
      ref={ref}
      value={value}
      placeholder={placeholder}
    />
  ));
  return (
    <>
      <div className={`relative ${props.className}`}>
        <DatePicker
          selected={startDate}
          excludeDateIntervals={null}
          onChange={(date: Date) => {
            setStartDate(date);
            const fv =
              (context.getFilterValue && context.getFilterValue(props.param)) ||
              [];

            context.setFilterValue &&
              context.setFilterValue(props.param, [
                date.toISOString().substring(0, 10),
                fv[1] || "",
              ]);
          }}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          customInput={<CustomInput />}
          placeholderText={"Start Date"}
        />
        <div className="absolute right-0 bottom-0 top-0 py-2">
          <BiCalendar className="text-lg" />
        </div>
      </div>
      <div className={`relative ${props.className}`}>
        <DatePicker
          selected={endDate}
          excludeDateIntervals={null}
          onChange={(date: Date) => {
            setEndDate(date);
            const fv =
              (context.getFilterValue && context.getFilterValue(props.param)) ||
              [];

            context.setFilterValue &&
              context.setFilterValue(props.param, [
                fv[0] || "",
                date.toISOString().substring(0, 10),
              ]);
          }}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={startDate}
          customInput={<CustomInput />}
          placeholderText={"End Date"}
        />
        <div className="absolute right-0 bottom-0 top-0 py-2">
          <BiCalendar className="text-lg" />
        </div>
      </div>
    </>
  );
};

export default DateRange;
